module.exports = __webpack_public_path__ + "media/images/partner/media/koelnische_rundschau-a3f3276f39a8289898e373e2b6da8b80.png";